import EachReferralDashboard from "../components/EachReferralDashboard";
import NavigationBar from "../components/NavigationBar";
import Footer from "../components/Footer";
function EachReferralDashboardPage() {
	return (
		<>
			<NavigationBar />
			<EachReferralDashboard />
			<Footer />
		</>
	);
}

export default EachReferralDashboardPage;
